import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 20px;
    justify-content: center;
`;

export const ContainerStyled = styled.div`
    border: solid 2px ${ ({ available, theme: { dangerColor, successColor } }) => available ? successColor : dangerColor };
    border-radius: 10px;
    color: ${ getTheme('textColor') };
    max-width: 850px;
    padding: 20px 20px 10px 20px;
`;

export const Content = styled.div`

`;

export const GroupContainer = styled.div`
    align-items: center;
    display: flex;
`;
